import { TooltipProvider } from '@aibi/ui';
import { useReportRoute } from '../report/report-route';
import { ReportView } from '../report/ReportView';
import { SettingsView } from '../settings/SettingsView';
import { StatusBar } from '../workspace/components/shell/StatusBar';
import { AnalysisWorkspace } from '../workspace/AnalysisWorkspace';
import { useUiState } from '../workspace/state/ui-state';
import { UiStateProvider } from '../workspace/state/UiStateProvider';

export function App() {
  return (
    <TooltipProvider>
      <UiStateProvider>
        <div className="flex h-screen flex-col overflow-hidden bg-background text-foreground">
          <Root />
        </div>
      </UiStateProvider>
    </TooltipProvider>
  );
}

/** Un enlace de reporte muestra solo el reporte: sin workspace, configuracion ni barra de estado. */
function Root() {
  const reportId = useReportRoute();
  if (reportId !== null) return <ReportView key={reportId} reportId={reportId} />;
  return (
    <>
      <ActiveView />
      <StatusBar />
    </>
  );
}

/** Al volver a Analisis el workspace se monta de nuevo y relee el catalogo de modelos. */
function ActiveView() {
  const { activeView } = useUiState();
  return activeView === 'analysis' ? <AnalysisWorkspace /> : <SettingsView section={activeView} />;
}
